export const talledosLightTheme = {
  colors: {
    text: '#111111',
    background: '#ffffff',
    primary: '#B89C54',
    secondary: '#C6A95B',
    hover: '#f1f1f1',
    muted: '#e0e0e0',
    highlight: '#fcf3e3',
    accent: 'rgba(0, 0, 0, 0.05)',
    textMuted: 'rgba(0, 0, 0, 0.6)',
    textSubtle: 'rgba(0, 0, 0, 0.4)',
    overlay: 'rgba(0, 0, 0, 0.25)',
    shadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
    shadowSm: '0 2px 8px rgba(0, 0, 0, 0.05)',
    shadowMd: '0 4px 24px rgba(0, 0, 0, 0.08)',
    surface: 'rgba(0, 0, 0, 0.02)',
    surfaceElevated: 'rgba(0, 0, 0, 0.05)',
    surfaceMuted: 'rgba(0, 0, 0, 0.08)',
    inputBorder: 'rgba(184, 156, 84, 0.4)',
    inputBorderSubtle: 'rgba(184, 156, 84, 0.2)',
    placeholder: 'rgba(0, 0, 0, 0.4)',
    error: '#e03131',
    success: '#2b8a5e',
    onImage: '#ffffff',
    codeBg: '#f4f5f7',
    codeText: '#5c6a00',
    borderSubtle: 'rgba(0, 0, 0, 0.1)',
    autofillBg: '#e8f0fe',
    iconHover: 'rgba(0, 0, 0, 0.08)',
    badgeOnImage: 'rgba(184, 156, 84, 0.9)',
    shareDialogBg: '#ffffff',
    shareDialogText: '#111111',
    shareDialogTextMuted: 'rgba(0, 0, 0, 0.6)',
    shareDialogHover: 'rgba(0, 0, 0, 0.05)',
    avatarBorder: '#ffffff',
  },
};
